import styled from "styled-components";

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 500px;
  margin: 1rem 0;
`;

export const Button = styled.button`
  cursor: pointer;
  font-size: 16px;
  background: none;
  margin: 1rem 0;
  border: none;
  text-decoration: underline;
  text-align: left;
`;

export const Thumbnail = styled.img`
  display: block;
  max-width: 260px;
  margin: 1rem 0;
  border-radius: 8px;
  cursor: pointer;
`;

export const VideoContainer = styled.div`
  position: relative;
  max-width: 260px; /* Match the thumbnail width */
  margin: 1rem 0;
`;

export const Iframe = styled.iframe`
  width: 100%;
  height: 146px; /* Maintain 16:9 aspect ratio for 260px width */
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Add a subtle shadow for consistency */
`;
